//api/master-data/admin/options/features

import React from 'react'
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { featuresOptionsMap, userPayload } from "Pages/Admin/Users/@signals"
import { BACKEND_APIS } from "@constants"

export default function UserFeaturesField() {

	const { extraFeatures, setExtraFeaturesInfo } = useAdminUsersInfo(userPayload.peek()?.user?.extraFeatures, "extraFeatures", "user")


	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false}
		multiple
		value={extraFeatures}
		label="Features"
		placeholder="Features for the user"
		onChange={e => setExtraFeaturesInfo(e.target.value)}
		onFinishAjax={options => {
			featuresOptionsMap.value = { ...featuresOptionsMap.value, ...Object.fromEntries(options.map(o => [String(o.value), o.label])) }
		}}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/features`}
	/>
}